import { useEffect } from "react";
import { useAgentSdk } from "@/sdk";

import { useChatStore } from "./chat.store";
import type { ChatMessage } from "./chatMessage";
import type { ChatTask } from "./chatTask";

export function useActiveChatMessages(activeChatTask: ChatTask): ChatMessage[] {
    const agentSdk = useAgentSdk();
    const chats = useChatStore((state) => state.chats);
    const chatMessages = chats.get(activeChatTask.chatId) || new Map<string, ChatMessage>();

    // TODO:// find a way to call getMessages within creation of new task (currently doesn't work bc of race-condition)
    useEffect(() => {
        if (activeChatTask.status !== "assigned") return;
        if (chatMessages.size > 0) return;

        void agentSdk.getMessages(activeChatTask);
    }, [activeChatTask, agentSdk, chatMessages.size]);

    return Array.from(chatMessages.values()).sort((a, b) => a.index - b.index);
}
